import { render, staticRenderFns } from "./StatusStammdaten.vue?vue&type=template&id=f3a02b3a&"
import script from "./StatusStammdaten.vue?vue&type=script&lang=js&"
export * from "./StatusStammdaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports